import { getField, updateField } from 'vuex-map-fields';
import apiAxios from '../../services/apiAxios';
import helpers from '../../mixins/helpers';

const state = {
    id: 0,
    nombre: '',
    inactivo: false,
    rowVersion: null,
    
    datos: [],
};

const mutations = {
    updateField,

    'INICIALIZAR_CONCEPTO'(state, presupuestoGastosConceptoId) {
        state.id = presupuestoGastosConceptoId;
        state.nombre = '';
        state.inactivo = false;
        state.rowVersion = null;
    },
    'SET_CONCEPTO'(state, presupuestoGastosConcepto) {
        state.nombre = presupuestoGastosConcepto.nombre.toUpperCase().trim();
        state.inactivo = presupuestoGastosConcepto.inactivo;
        state.rowVersion = presupuestoGastosConcepto.rowVersion;
    },

    'INICIALIZAR_DATOS'(state) {
        state.datos = [];
    },
    'SET_DATOS'(state, params) {
        state.datos = params.datos;
    },
};

const getters = {
    getField,

    presupuestoGastosConcepto(state) {
        return {
            id: state.id,
            nombre: state.nombre.toUpperCase().trim(),
            inactivo: state.inactivo,
            rowVersion: state.rowVersion,
        }
    }
};

const actions = {
    inicializar ( { commit }, presupuestoGastosConceptoId ) {
        return new Promise((resolve, reject) => {
            commit('INICIALIZAR_CONCEPTO', presupuestoGastosConceptoId);
            
            if (presupuestoGastosConceptoId != 0){
                apiAxios.get(`presupuestos-gastos-conceptos/${presupuestoGastosConceptoId}/abm`) 
                    .then(res => {
                        commit('SET_CONCEPTO', res.data);
                        resolve();
                    })
                    .catch(error => reject(helpers.methods.getErrorMessage(error)));
            } else {
                resolve();
            }
        })
    },    
    save ( {} ) {
        return new Promise((resolve, reject) => {
            let presupuestoGastosConcepto= {
                nombre: state.nombre.toUpperCase().trim(),
                inactivo: state.inactivo,
            }
            
            let url = 'presupuestos-gastos-conceptos';
            if (state.id != 0) {
                url += '/' + state.id;
                presupuestoGastosConcepto.rowVersion = state.rowVersion;
            }

            apiAxios.post(url, presupuestoGastosConcepto)
                .then(() => resolve())
                .catch(error => reject(helpers.methods.getErrorMessage(error)));
        })
    },

    getDatos ( { commit }, presupuestoGastosConceptoId ) {
        return new Promise((resolve, reject) => {
            commit('INICIALIZAR_DATOS');

            if (presupuestoGastosConceptoId != 0) {
                apiAxios.get(`presupuestos-gastos-conceptos/${presupuestoGastosConceptoId}`) 
                    .then(res => {
                        let datos = [
                            { 'nombre': 'nombre', 'campo': 'Nombre', 'valor': res.data.nombre, 'formato': '' },
                            { 'nombre': 'inactivo', 'campo': 'Inactivo', 'valor': res.data.inactivo? 'Si' : 'No', 'formato': '' },
                        ];
                        let params = {
                            datos: datos,
                        }
                        commit('SET_DATOS', params);
                        resolve();
                    })
                    .catch(error => reject(helpers.methods.getErrorMessage(error)));
            } else {
                resolve();
            }
        })            
    },
};

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
}